import React, { useEffect, useState } from "react";
import Form from "react-bootstrap/Form";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import { useForm } from "react-hook-form";
import {} from "../../../../system";
import { UserActions } from "../../../../redux/actions/user.actions";
import Button from "react-bootstrap/Button";
import "react-datepicker/dist/react-datepicker.css";
import { allSharedComponents } from "../../../../shared";
import {
  emptyString,
  translationConstants,
  modeConstants,
  fieldLengthConstants,
  Directions,
} from "../../../../constants";

const initialFormData = {
  id: "",
  englishFirstName: "",
  arabicFirstName: "",
  email: "",
  countryId: 1,
  arabicLastName: "",
  englishLastName: "",
  isActive: true,
  nationality: "",
  phoneNumber: "",
  preferredLangauge: 0,
  bloodGroup: "",
};

const AdminUserForm = (props) => {
  const dispatch = useDispatch();
  const userData = useSelector((state) => state.UserReducer.adminUserData);
  const [formData, setFormData] = useState(initialFormData);
  const {
    setValue,
    register,
    handleSubmit,
    formState: { errors },
    trigger,
  } = useForm();
  const { t } = useTranslation();
  const { SpinnerContainer } = allSharedComponents;

  const onSubmit = (data) => {
    props.setShow(false);

    if (props.mode === modeConstants.ADD_MODE) {
      dispatch(UserActions.createAdminUser(formData));
    } else if (props.mode === modeConstants.EDIT_MODE) {
      dispatch(UserActions.updateAdminUser(formData, props.gridState));
    }
  };

  useEffect(() => {
    if (
      props.mode === modeConstants.EDIT_MODE ||
      props.mode === modeConstants.VIEW_MODE
    ) {
      //Set initial form values from userData if they are defined
      setFormData((prevData) => ({
        ...prevData,
        id: userData.id || emptyString,
        englishFirstName: userData.englishFirstName || emptyString,
        arabicFirstName: userData.arabicFirstName || emptyString,
        email: userData.email || emptyString,
      }));

      // Set form values using setValue only if they are defined
      userData.englishFirstName &&
        setValue("englishFirstName", userData.englishFirstName);
      userData.arabicFirstName &&
        setValue("arabicFirstName", userData.arabicFirstName);
      userData.email && setValue("email", userData.email);
    }
    // eslint-disable-next-line
  }, [userData]);

  return (
    <section>
      <div className="ViewHeader">
        <p className="viewUserPara">
          {props.mode === modeConstants.EDIT_MODE
            ? t(translationConstants.EDIT_ADMIN_USER)
            : props.mode === modeConstants.ADD_MODE
            ? t(translationConstants.ADD_ADMIN_USER)
            : t(translationConstants.VIEW_ADMIN_USER)}
        </p>
      </div>
      <p className="horizentalLine" />
      <div className="m-t-24">
        <Form
          noValidate
          className="ViewUserContent"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="d-flex justify-content-center mt-12">
            <Form.Group className="form-group-register">
              <Form.Label className="Form-labels">
                {t(translationConstants.name)}:
              </Form.Label>
              <Form.Control
                {...register("englishFirstName", {
                  required: t(translationConstants.NAME_REQUIRED),
                  pattern: {
                    value: /^[A-Za-z\s]+$/i,
                    message: t(translationConstants.INVALID_NAME),
                  },
                })}
                value={formData?.englishFirstName}
                onChange={(e) => {
                  setValue("englishFirstName", e.target.value, {
                    shouldValidate: true,
                  });
                  trigger("englishFirstName");
                  setFormData({
                    ...formData,
                    englishFirstName: e.target.value,
                  });
                }}
                id="englishFirstName"
                type="text"
                maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
                placeholder={t(translationConstants.ENTER_NAME)}
                disabled={props.mode === modeConstants.VIEW_MODE}
              />
              {errors.englishFirstName && (
                <p className="errorText">{errors.englishFirstName.message}</p>
              )}
            </Form.Group>
          </div>

          <div className="d-flex justify-content-center mt-12">
            <Form.Group className="form-group-register">
              <Form.Label className="Form-labels">
                {t(translationConstants.name)}:{" "}
                <span>({t(translationConstants.ARABIC)})</span>{" "}
              </Form.Label>
              <Form.Control
                {...register("arabicFirstName", {
                  // ... your existing rules
                })}
                onChange={(e) => {
                  setValue("arabicFirstName", e.target.value, {
                    shouldValidate: true,
                  });
                  trigger("arabicFirstName");
                  setFormData({
                    ...formData,
                    arabicFirstName: e.target.value,
                  });
                }}
                id="arabicFirstName"
                type="text"
                maxLength={fieldLengthConstants.TEXT_FIELD_LENGTH}
                value={formData?.arabicFirstName}
                placeholder="آسجد"
                style={{ direction: Directions.rtl }}
                disabled={props.mode === modeConstants.VIEW_MODE}
              />
              {errors.arabicFirstName && (
                <p className="errorText">{errors.arabicFirstName.message}</p>
              )}
            </Form.Group>
          </div>

          <div className="d-flex justify-content-center mt-12">
            <Form.Group className="form-group-register">
              <Form.Label className="Form-labels">
                {t(translationConstants.email)}
              </Form.Label>
              <Form.Control
                {...register("email", {
                  required: t(translationConstants.emailRequired),
                  pattern: {
                    value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{1,}$/i,
                    message: t(translationConstants.invalidEmail),
                  },
                })}
                value={formData?.email}
                onChange={(e) => {
                  setValue("email", e.target.value, {
                    shouldValidate: true,
                  });
                  trigger("email");
                  setFormData({
                    ...formData,
                    email: e.target.value,
                  });
                }}
                id="email"
                type="text"
                maxLength={fieldLengthConstants.EMAIL_FIELD_LENGTH}
                placeholder={t(translationConstants.email)}
                disabled={props.mode === modeConstants.VIEW_MODE}
              />
              {errors.email && (
                <p className="errorText">{errors.email.message}</p>
              )}
            </Form.Group>
          </div>

          {props.mode === modeConstants.EDIT_MODE ? (
            <div className="d-flex justify-content-center">
              <Button className="SubmitDocs-button" type="submit">
                {t(translationConstants.Update)}
              </Button>
            </div>
          ) : props.mode === modeConstants.ADD_MODE ? (
            <Button className="SubmitDocs-button" type="submit">
              {t(translationConstants.submit)}
            </Button>
          ) : (
            ""
          )}
        </Form>
      </div>
    </section>
  );
};

export default AdminUserForm;
